import { FC } from "react";
import "./KioskHome.css";
import { useAppSelector } from "@store/store";
import { selectMenuItemsWithPlan } from "@store/menuItem/menuItemReducer";
import { selectClient } from "@store/client/clientReducer";
import { useWindowSize } from "@hooks/useWindowSize/useWindowSize";
import { EntityMenuItem } from "../MenuItem/EntityMenuItem";
import { ClientLinkMenuItem } from "../MenuItem/ClientLinkMenuItem";
import { selectIsHomeMenuOpen } from "@store/kiosk/kioskReducer";
import { selectKioskClientLinks } from "@store/clientLinks/clientLinksReducer";
export const KioskHome: FC = () => {
  const client = useAppSelector(selectClient)!;
  const menuItemsWithPlan = useAppSelector(selectMenuItemsWithPlan);
  const { orientation } = useWindowSize();
  const isHomeMenuOpen = useAppSelector(selectIsHomeMenuOpen);
  const kioskClientLinks = useAppSelector(selectKioskClientLinks);
  if (!isHomeMenuOpen) {
    return null;
  }

  return (
    <div
      className="kiosk-menu"
      data-testid="kiosk-menu"
      style={{
        backgroundImage:
          orientation === "LANDSCAPE"
            ? `url(${client.kioskFeature.menuImageUrlLandscape})`
            : `url(${client.kioskFeature.menuImageUrlPortrait})`,
      }}>
      <ul className="list-menu-items">
        {kioskClientLinks.priorityClientLinks.map((clientLink) => (
          <ClientLinkMenuItem key={clientLink.id} clientLink={clientLink} />
        ))}

        {menuItemsWithPlan.map((menuItem) => {
          return <EntityMenuItem key={menuItem.id} menuItem={menuItem} />;
        })}

        {kioskClientLinks.nonPriorityClientLinks.map((clientLink) => (
          <ClientLinkMenuItem key={clientLink.id} clientLink={clientLink} />
        ))}
      </ul>
    </div>
  );
};
